import moment from 'moment'

export const momentUTC = moment.utc
